@for (month of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; track $index) {
  <cal-month [month]="month" [year]="ss.calendar?.year" class="year"></cal-month>
}
